export default "__VITE_ASSET__C_8m55IA__"